/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type { DismissWhatsNewRequest, WhatsNewStateResponse } from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getProductUpdates = () => {
  /**
   * The caller's first visit and the updates they have already closed.
   * @summary Get Whats New State
   */
  const productUpdatesGetWhatsNewState = (
    options?: SecondParameter<typeof axiosInstance<WhatsNewStateResponse>>
  ) => {
    return axiosInstance<WhatsNewStateResponse>(
      { url: `/product-updates/whats-new`, method: 'GET' },
      options
    );
  };
  /**
   * Remember that the caller closed or opened these updates.
   * @summary Dismiss Whats New Updates
   */
  const productUpdatesDismissWhatsNewUpdates = (
    dismissWhatsNewRequest: DismissWhatsNewRequest,
    options?: SecondParameter<typeof axiosInstance<WhatsNewStateResponse>>
  ) => {
    return axiosInstance<WhatsNewStateResponse>(
      {
        url: `/product-updates/whats-new/dismiss`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: dismissWhatsNewRequest,
      },
      options
    );
  };
  return {
    productUpdatesGetWhatsNewState,
    productUpdatesDismissWhatsNewUpdates,
  };
};
export type ProductUpdatesGetWhatsNewStateResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getProductUpdates>['productUpdatesGetWhatsNewState']
    >
  >
>;
export type ProductUpdatesDismissWhatsNewUpdatesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getProductUpdates
      >['productUpdatesDismissWhatsNewUpdates']
    >
  >
>;
